<template>
  <!-- <button id="btn" @click="testOcr" style="position: fixed; z-index: 9999999;">获取图片</button> -->
  <div class="mindar-box">
    <div ref="container" id="container"></div>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, onUnmounted } from 'vue';
import { eventBus } from "@/utils/eventBus"
import * as THREE from 'three';
import { MindARThree } from 'mind-ar/build/mindar-image-three.prod.js';
import { ocrAliyunByBlob } from "@/api/service"

export default {
  emits: ['onTargetFound'],
  setup(props, { emit }) {
    const container = ref(null);
    let mindarThree = null;
    let scene = null;
    let camera = null;
    let renderer = null;
    let anchor = null;
    let timer = null;
    let isOcring = true;
    let isFinish = false;
    let counts = 0;

    const initAR = async () => {
      if (!container.value) return;
      //重新扫描的时候需要恢复
      eventBus.on('message', handleMessage);
      mindarThree = new MindARThree({
        container: container.value,
        imageTargetSrc: `${process.env.VUE_APP_CDN_URL}/target/ssd.mind`
      });

      ({ renderer, scene, camera } = mindarThree);
      const geometry = new THREE.PlaneGeometry(1, 0.34);
      const material = new THREE.MeshBasicMaterial({
        color: 0x00ffff,
        transparent: true,
        opacity: 0.5
      });
      const plane = new THREE.Mesh(geometry, material);
      let count = 19; //
      for (let i = 0; i < count; i++) {
        const anchor = mindarThree.addAnchor(i);

        anchor.onTargetFound = () => {
          anchor.group.add(plane);
          console.log(anchor.group)
          console.log('发现目标，识别中...')
          counts = counts + 1;
          console.log('timer' + timer)
          isOcring = false;
          console.log('isFinish0', isFinish)
          if (!isFinish) {
            console.log('isFinish1', isFinish)
            // 显示所有锚点
            mindarThree.anchors.forEach(anchor => {
              anchor.group.visible = true;
            });
            //mindarThree.renderer.render(mindarThree.scene, mindarThree.camera);
          } else {
            hideAllAnchors();
          }

          // renderer.setAnimationLoop(() => {
          //   renderer.render(scene, camera);
          // });

          // setTimeout(function () {
          //   pauseAR();
          //   //emit('onTargetFound', { message: 'found', model: 'model1' }) // 触发事件并传递数据

          // }, 2000);
        };
        anchor.onTargetLost = () => {
          console.log('目标丢失')
        };
      }
      startAR();
    };

    //重新扫描注册
    const handleMessage = () => {
      resumeAR();
    }

    //启动
    const startAR = async () => {
      if (!mindarThree) await initAR();
      await mindarThree.start();
      renderer.setAnimationLoop(() => {
        renderer.render(scene, camera);
      });
    };

    //停止
    const stopAR = () => {
      if (!mindarThree) return;
      if (timer) {
        console.log('clearInterval timer')
        clearInterval(timer);
        timer = null;
      }
      mindarThree.controller.stopProcessVideo();
      mindarThree.stop();
      mindarThree.renderer.setAnimationLoop(null);
      renderer.render(scene, camera);
    };

    //暂停
    const pauseAR = () => {
      mindarThree.controller.stopProcessVideo();
      mindarThree.renderer.setAnimationLoop(null);
      hideAllAnchors();

    }

    // 恢复AR的函数
    const resumeAR = async () => {
      if (!mindarThree) return;
      console.log('resumeAR');
      //重新开始处理视频
      mindarThree.controller.processVideo(mindarThree.video);
      //设置可见
      mindarThree.anchors.forEach(anchor => {
        anchor.group.visible = false;
      });

      renderer.setAnimationLoop(() => {
        renderer.render(scene, camera);
      });

      //mindarThree.start();
      isOcring = true;
      isFinish = false;

      // 恢复渲染循环
      if (!timer) {
        console.log('resumeAR：', 'handleTakePhoto')
        timer = setInterval(handleTakePhoto, 1000);
      }
    };

    const handleTakePhoto_test = async () => {
      console.log(counts)
      if (counts > 1) {
        let obj = Object.assign({ message: 'found' }, { name: "ssdzy", path: "ssdzy" })
        emit('onTargetFound', obj) // 触发事件并传递数据
        //eventBus.emit('playAnimate', 'play')
        isFinish = true
        console.log('timer:' + timer)
        if (timer) {
          console.log('销毁')
          clearInterval(timer);
          timer = null
          console.log('销毁timer:' + timer)
        }
        pauseAR();
      }
    }

    //ocr图片
    const handleTakePhoto = async () => {
      console.log(1)
      if (isOcring) return;
      if (isFinish) return;
      console.log(2)
      isOcring = true;
      const formData = new FormData();
      formData.append('file', await takePhoto());
      ocrAliyunByBlob(formData).then(res => {
        if (res.detail === 'OCR识别失败') {
          isOcring = false;
        } else {
          let product = findProduct(res);
          console.log(product);
          if (!product) return;
          let obj = Object.assign({ message: 'found' }, product);
          console.log("onTargetFound:");
          console.log(obj);
          //eventBus.emit('playAnimate', 'play')
          console.log('timer:' + timer);
          if (timer) {
            isFinish = true;
            console.log('销毁+isFinish：' + isFinish);
            clearInterval(timer);
            timer = null;
            console.log('销毁timer:' + timer);
            pauseAR();
            emit('onTargetFound', obj); // 触发事件并传递数据
          }

        }
      }).catch(error => {
        isOcring = false;
        console.error('OCR failed11111:', error);
      });
    };

    //提取video实时图片
    async function takePhoto() {
      return new Promise(async (resolve, reject) => {

        if (!mindarThree.video) {
          throw new Error('No video element found');
        }
        const video = mindarThree.video;
        if (!video) {
          throw new Error('No video element found');
        }
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;

        const canvas = (() => {
          const canvas = document.createElement('canvas');
          canvas.width = videoWidth;
          canvas.height = videoHeight;
          return canvas;
        })();

        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight);

        const blob = await new Promise(resolve => {
          canvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/jpeg', 1);
        });
        if (!blob) {
          reject('-1');
        }
        resolve(blob);
      });
    }

    const testOcr = () => {
      let content = `"{\"algo_version\":\"\",\"angle\":270,\"content\":\"X W 模板 Al in Action Create AKS RITM5053... 扶他林MVP 设计文件 演示动画 图片4 Haleon Module O... Cluster fo...- -Pain Free... 动作梳理表 Quotatio... 组 编辑 Q 四 @ C 图片11.png X 三 科学研究证实有效抗敏感牙膏 新包装 HALEON 并在一起再传回系统 SENSODYNE PRO专业 舒适达 专业修复器 NOVAMIN成分 源自牙本质修护技术 根源修复从内重塑牙本质 从外强韧牙屏障 劲爽薄荷 Q 91% 三 ① 品 1558x481 图 682.1KB \",\"height\":720,\"orgHeight\":1280,\"orgWidth\":720,\"prism_version\":\"1.0.9\",\"prism_wnum\":46,\"prism_wordsInfo\":[{\"angle\":-90,\"direction\":0,\"height\":15,\"pos\":[{\"x\":288,\"y\":34},{\"x\":303,\"y\":34},{\"x\":303,\"y\":51},{\"x\":288,\"y\":51}],\"prob\":99,\"width\":17,\"word\":\"X\",\"x\":287,\"y\":35},{\"angle\":-90,\"direction\":0,\"height\":18,\"pos\":[{\"x\":579,\"y\":42},{\"x\":598,\"y\":42},{\"x\":598,\"y\":58},{\"x\":579,\"y\":58}],\"prob\":99,\"width\":16,\"word\":\"W\",\"x\":580,\"y\":41},{\"angle\":-88,\"direction\":0,\"height\":29,\"pos\":[{\"x\":0,\"y\":61},{\"x\":29,\"y\":62},{\"x\":28,\"y\":75},{\"x\":0,\"y\":74}],\"prob\":98,\"width\":13,\"word\":\"模板\",\"x\":7,\"y\":54},{\"angle\":-88,\"direction\":0,\"height\":73,\"pos\":[{\"x\":42,\"y\":64},{\"x\":116,\"y\":66},{\"x\":115,\"y\":78},{\"x\":41,\"y\":76}],\"prob\":96,\"width\":11,\"word\":\"Al in Action\",\"x\":72,\"y\":34},{\"angle\":-88,\"direction\":0,\"height\":79,\"pos\":[{\"x\":117,\"y\":66},{\"x\":197,\"y\":69},{\"x\":197,\"y\":81},{\"x\":117,\"y\":78}],\"prob\":99,\"width\":12,\"word\":\"Create AKS\",\"x\":151,\"y\":34},{\"angle\":-88,\"direction\":0,\"height\":80,\"pos\":[{\"x\":186,\"y\":68},{\"x\":267,\"y\":69},{\"x\":266,\"y\":82},{\"x\":186,\"y\":80}],\"prob\":99,\"width\":12,\"word\":\"RITM5053...\",\"x\":220,\"y\":35},{\"angle\":-89,\"direction\":0,\"height\":67,\"pos\":[{\"x\":267,\"y\":70},{\"x\":335,\"y\":70},{\"x\":335,\"y\":83},{\"x\":267,\"y\":82}],\"prob\":99,\"width\":12,\"word\":\"扶他林MVP\",\"x\":295,\"y\":42},{\"angle\":-89,\"direction\":0,\"height\":50,\"pos\":[{\"x\":352,\"y\":70},{\"x\":402,\"y\":71},{\"x\":402,\"y\":84},{\"x\":352,\"y\":83}],\"prob\":99,\"width\":12,\"word\":\"设计文件\",\"x\":370,\"y\":52},{\"angle\":-89,\"direction\":0,\"height\":49,\"pos\":[{\"x\":424,\"y\":72},{\"x\":473,\"y\":72},{\"x\":473,\"y\":85},{\"x\":424,\"y\":84}],\"prob\":99,\"width\":12,\"word\":\"演示动画\",\"x\":442,\"y\":54},{\"angle\":-88,\"direction\":0,\"height\":34,\"pos\":[{\"x\":506,\"y\":74},{\"x\":541,\"y\":75},{\"x\":540,\"y\":88},{\"x\":506,\"y\":87}],\"prob\":99,\"width\":12,\"word\":\"图片4\",\"x\":517,\"y\":64},{\"angle\":-88,\"direction\":0,\"height\":42,\"pos\":[{\"x\":576,\"y\":77},{\"x\":619,\"y\":78},{\"x\":618,\"y\":91},{\"x\":576,\"y\":89}],\"prob\":99,\"width\":12,\"word\":\"Haleon\",\"x\":591,\"y\":63},{\"angle\":-88,\"direction\":0,\"height\":80,\"pos\":[{\"x\":42,\"y\":80},{\"x\":122,\"y\":81},{\"x\":122,\"y\":94},{\"x\":41,\"y\":92}],\"prob\":97,\"width\":12,\"word\":\"Module O...\",\"x\":76,\"y\":46},{\"angle\":-88,\"direction\":0,\"height\":83,\"pos\":[{\"x\":118,\"y\":82},{\"x\":202,\"y\":84},{\"x\":201,\"y\":96},{\"x\":118,\"y\":94}],\"prob\":97,\"width\":12,\"word\":\"Cluster fo...-\",\"x\":154,\"y\":47},{\"angle\":-88,\"direction\":0,\"height\":68,\"pos\":[{\"x\":197,\"y\":84},{\"x\":266,\"y\":86},{\"x\":266,\"y\":98},{\"x\":197,\"y\":96}],\"prob\":99,\"width\":11,\"word\":\"-Pain Free...\",\"x\":226,\"y\":56},{\"angle\":-89,\"direction\":0,\"height\":64,\"pos\":[{\"x\":269,\"y\":85},{\"x\":333,\"y\":85},{\"x\":333,\"y\":98},{\"x\":269,\"y\":98}],\"prob\":99,\"width\":12,\"word\":\"动作梳理表\",\"x\":294,\"y\":60},{\"angle\":-87,\"direction\":0,\"height\":61,\"pos\":[{\"x\":567,\"y\":92},{\"x\":629,\"y\":95},{\"x\":628,\"y\":107},{\"x\":566,\"y\":105}],\"prob\":99,\"width\":12,\"word\":\"Quotatio...\",\"x\":591,\"y\":69},{\"angle\":-90,\"direction\":0,\"height\":16,\"pos\":[{\"x\":27,\"y\":122},{\"x\":43,\"y\":122},{\"x\":43,\"y\":137},{\"x\":27,\"y\":137}],\"prob\":67,\"width\":15,\"word\":\"组\",\"x\":27,\"y\":121},{\"angle\":-90,\"direction\":0,\"height\":27,\"pos\":[{\"x\":36,\"y\":122},{\"x\":63,\"y\":122},{\"x\":63,\"y\":137},{\"x\":36,\"y\":137}],\"prob\":97,\"width\":14,\"word\":\"编辑\",\"x\":42,\"y\":116},{\"angle\":-90,\"direction\":0,\"height\":16,\"pos\":[{\"x\":86,\"y\":121},{\"x\":103,\"y\":121},{\"x\":103,\"y\":141},{\"x\":86,\"y\":141}],\"prob\":98,\"width\":19,\"word\":\"Q\",\"x\":85,\"y\":123},{\"angle\":-90,\"direction\":0,\"height\":14,\"pos\":[{\"x\":129,\"y\":123},{\"x\":143,\"y\":123},{\"x\":143,\"y\":142},{\"x\":129,\"y\":142}],\"prob\":82,\"width\":18,\"word\":\"四\",\"x\":127,\"y\":125},{\"angle\":-90,\"direction\":0,\"height\":17,\"pos\":[{\"x\":216,\"y\":126},{\"x\":233,\"y\":126},{\"x\":233,\"y\":143},{\"x\":216,\"y\":143}],\"prob\":91,\"width\":17,\"word\":\"@\",\"x\":216,\"y\":126},{\"angle\":-90,\"direction\":0,\"height\":15,\"pos\":[{\"x\":257,\"y\":126},{\"x\":273,\"y\":126},{\"x\":273,\"y\":142},{\"x\":257,\"y\":142}],\"prob\":77,\"width\":15,\"word\":\"C\",\"x\":257,\"y\":126},{\"angle\":-86,\"direction\":0,\"height\":61,\"pos\":[{\"x\":524,\"y\":134},{\"x\":585,\"y\":138},{\"x\":585,\"y\":151},{\"x\":523,\"y\":147}],\"prob\":99,\"width\":12,\"word\":\"图片11.png\",\"x\":548,\"y\":111},{\"angle\":-90,\"direction\":0,\"height\":15,\"pos\":[{\"x\":1037,\"y\":156},{\"x\":1053,\"y\":156},{\"x\":1053,\"y\":169},{\"x\":1037,\"y\":169}],\"prob\":68,\"width\":13,\"word\":\"X\",\"x\":1039,\"y\":155},{\"angle\":-90,\"direction\":0,\"height\":9,\"pos\":[{\"x\":868,\"y\":254},{\"x\":877,\"y\":254},{\"x\":877,\"y\":264},{\"x\":868,\"y\":264}],\"prob\":99,\"width\":10,\"word\":\"三\",\"x\":867,\"y\":255},{\"angle\":-89,\"direction\":0,\"height\":232,\"pos\":[{\"x\":434,\"y\":280},{\"x\":666,\"y\":283},{\"x\":665,\"y\":302},{\"x\":433,\"y\":299}],\"prob\":99,\"width\":19,\"word\":\"科学研究证实有效抗敏感牙膏\",\"x\":540,\"y\":175},{\"angle\":-89,\"direction\":0,\"height\":64,\"pos\":[{\"x\":0,\"y\":289},{\"x\":64,\"y\":289},{\"x\":64,\"y\":311},{\"x\":0,\"y\":310}],\"prob\":99,\"width\":21,\"word\":\"新包装\",\"x\":21,\"y\":267},{\"angle\":-88,\"direction\":0,\"height\":57,\"pos\":[{\"x\":997,\"y\":306},{\"x\":1055,\"y\":307},{\"x\":1054,\"y\":319},{\"x\":997,\"y\":318}],\"prob\":98,\"width\":12,\"word\":\"HALEON\",\"x\":1020,\"y\":284},{\"angle\":-89,\"direction\":0,\"height\":106,\"pos\":[{\"x\":1066,\"y\":319},{\"x\":1173,\"y\":321},{\"x\":1173,\"y\":336},{\"x\":1066,\"y\":335}],\"prob\":99,\"width\":15,\"word\":\"并在一起再传回系统\",\"x\":1112,\"y\":275},{\"angle\":-89,\"direction\":0,\"height\":232,\"pos\":[{\"x\":44,\"y\":336},{\"x\":277,\"y\":339},{\"x\":276,\"y\":369},{\"x\":43,\"y\":367}],\"prob\":99,\"width\":30,\"word\":\"SENSODYNE\",\"x\":145,\"y\":237},{\"angle\":-89,\"direction\":0,\"height\":128,\"pos\":[{\"x\":723,\"y\":354},{\"x\":852,\"y\":355},{\"x\":852,\"y\":382},{\"x\":723,\"y\":381}],\"prob\":99,\"width\":27,\"word\":\"PRO专业\",\"x\":774,\"y\":304},{\"angle\":-87,\"direction\":0,\"height\":454,\"pos\":[{\"x\":53,\"y\":362},{\"x\":507,\"y\":381},{\"x\":501,\"y\":514},{\"x\":47,\"y\":495}],\"prob\":99,\"width\":133,\"word\":\"舒适达\",\"x\":211,\"y\":211},{\"angle\":-89,\"direction\":0,\"height\":204,\"pos\":[{\"x\":671,\"y\":397},{\"x\":876,\"y\":400},{\"x\":875,\"y\":444},{\"x\":670,\"y\":440}],\"prob\":99,\"width\":43,\"word\":\"专业修复器\",\"x\":751,\"y\":318},{\"angle\":-89,\"direction\":0,\"height\":106,\"pos\":[{\"x\":736,\"y\":457},{\"x\":842,\"y\":457},{\"x\":842,\"y\":472},{\"x\":736,\"y\":472}],\"prob\":99,\"width\":15,\"word\":\"NOVAMIN成分\",\"x\":781,\"y\":411},{\"angle\":-89,\"direction\":0,\"height\":120,\"pos\":[{\"x\":729,\"y\":471},{\"x\":849,\"y\":472},{\"x\":849,\"y\":487},{\"x\":728,\"y\":486}],\"prob\":99,\"width\":14,\"word\":\"源自牙本质修护技术\",\"x\":781,\"y\":419},{\"angle\":-89,\"direction\":0,\"height\":239,\"pos\":[{\"x\":46,\"y\":504},{\"x\":285,\"y\":507},{\"x\":285,\"y\":528},{\"x\":45,\"y\":525}],\"prob\":99,\"width\":20,\"word\":\"根源修复从内重塑牙本质\",\"x\":155,\"y\":396},{\"angle\":-89,\"direction\":0,\"height\":137,\"pos\":[{\"x\":286,\"y\":508},{\"x\":424,\"y\":510},{\"x\":424,\"y\":530},{\"x\":286,\"y\":528}],\"prob\":99,\"width\":19,\"word\":\"从外强韧牙屏障\",\"x\":345,\"y\":450},{\"angle\":0,\"direction\":0,\"height\":17,\"pos\":[{\"x\":945,\"y\":532},{\"x\":1019,\"y\":531},{\"x\":1019,\"y\":548},{\"x\":946,\"y\":550}],\"prob\":97,\"width\":73,\"word\":\"劲爽薄荷\",\"x\":945,\"y\":531},{\"angle\":-90,\"direction\":0,\"height\":12,\"pos\":[{\"x\":986,\"y\":647},{\"x\":999,\"y\":647},{\"x\":999,\"y\":662},{\"x\":986,\"y\":662}],\"prob\":99,\"width\":14,\"word\":\"Q\",\"x\":985,\"y\":648},{\"angle\":-1,\"direction\":0,\"height\":13,\"pos\":[{\"x\":743,\"y\":657},{\"x\":772,\"y\":656},{\"x\":772,\"y\":669},{\"x\":743,\"y\":670}],\"prob\":99,\"width\":29,\"word\":\"91%\",\"x\":743,\"y\":657},{\"angle\":-90,\"direction\":0,\"height\":13,\"pos\":[{\"x\":0,\"y\":656},{\"x\":13,\"y\":656},{\"x\":13,\"y\":675},{\"x\":0,\"y\":675}],\"prob\":74,\"width\":19,\"word\":\"三\",\"x\":-2,\"y\":658},{\"angle\":-90,\"direction\":0,\"height\":12,\"pos\":[{\"x\":106,\"y\":656},{\"x\":119,\"y\":656},{\"x\":119,\"y\":672},{\"x\":106,\"y\":672}],\"prob\":99,\"width\":16,\"word\":\"①\",\"x\":104,\"y\":657},{\"angle\":-90,\"direction\":0,\"height\":15,\"pos\":[{\"x\":146,\"y\":658},{\"x\":161,\"y\":658},{\"x\":161,\"y\":672},{\"x\":146,\"y\":672}],\"prob\":97,\"width\":13,\"word\":\"品\",\"x\":146,\"y\":657},{\"angle\":-89,\"direction\":0,\"height\":68,\"pos\":[{\"x\":167,\"y\":659},{\"x\":236,\"y\":659},{\"x\":236,\"y\":672},{\"x\":167,\"y\":672}],\"prob\":99,\"width\":12,\"word\":\"1558x481\",\"x\":195,\"y\":631},{\"angle\":-90,\"direction\":0,\"height\":16,\"pos\":[{\"x\":246,\"y\":658},{\"x\":262,\"y\":658},{\"x\":262,\"y\":673},{\"x\":246,\"y\":673}],\"prob\":98,\"width\":15,\"word\":\"图\",\"x\":247,\"y\":657},{\"angle\":-89,\"direction\":0,\"height\":55,\"pos\":[{\"x\":267,\"y\":658},{\"x\":323,\"y\":659},{\"x\":323,\"y\":674},{\"x\":267,\"y\":673}],\"prob\":99,\"width\":14,\"word\":\"682.1KB\",\"x\":288,\"y\":638}],\"width\":1280}"`
      findProduct(content)
    }

    const findProduct = (content) => {
      //console.log(content)
      const products = [
        // { name: 'ssdetb-cn', path: 'ssdetb', keywords: ['儿童牙膏', '6-12', '温和薄荷'] },
        // { name: 'ssdetb-cn', path: 'ssdetb', keywords: ['儿童牙膏', '6-i 2', '温和薄荷'] },
        // { name: 'ssdetb-en', path: 'ssdetb', keywords: ['for kids', '6-12', 'mild mint'] },
        // { name: 'ssdetb-en', path: 'ssdetb', keywords: ['for kids', '6-i 2', 'mild mint'] },
        // { name: 'ssdetc-cn', path: 'ssdetc', keywords: ['儿童牙膏', '6-12', '草莓口味'] },
        // { name: 'ssdetc-cn', path: 'ssdetc', keywords: ['儿童牙膏', '6-i 2', '草莓口味'] },
        // { name: 'ssdetc-en', path: 'ssdetc', keywords: ['for kids', '6-12', 'strawberry'] },
        // { name: 'ssdetc-en', path: 'ssdetc', keywords: ['for kids', '6-i 2', 'strawberry'] },
        // { name: 'ssdetn-cn', path: 'ssdetn', keywords: ['儿童牙膏', '2-6', '草莓口味'] },
        // { name: 'ssdetn-en', path: 'ssdetn', keywords: ['for kids', '2-6', 'strawberry'] },
        //  { name: 'ssdetb', path: 'ssdetb', keywords: ['儿童牙膏', '6-12', '温和薄荷'] },

        // { name: 'ssdetb', path: 'ssdetb', keywords: ['儿童牙膏', '6-12', '温和薄荷'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['儿童牙膏', '6-i 2', '温和薄荷'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['for kids', '6-12', 'mild mint'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['for kids', '6-i 2', 'mild mint'] },
        // { name: 'ssdetc', path: 'ssdetc', keywords: ['儿童牙膏', '6-12', '草莓口味'] },
        // { name: 'ssdetc', path: 'ssdetc', keywords: ['儿童牙膏', '6-i 2', '草莓口味'] },
        // { name: 'ssdetc', path: 'ssdetc', keywords: ['for kids', '6-12', 'strawberry'] },
        // { name: 'ssdetc', path: 'ssdetc', keywords: ['for kids', '6-i 2', 'strawberry'] },


         { name: 'ssdetb', path: 'ssdetb', keywords: ['儿童牙膏', '护釉健', '温和薄荷'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['儿童牙膏', '6-i 2', '温和薄荷'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['for kids', '6-12', 'mild mint'] },
        // { name: 'ssdetb', path: 'ssdetb', keywords: ['for kids', '6-i 2', 'mild mint'] },
        { name: 'ssdetc', path: 'ssdetc', keywords: ['儿童牙膏', '6-12', '草莓口味'] },
        { name: 'ssdetc', path: 'ssdetc', keywords: ['儿童牙膏', '6-i 2', '草莓口味'] },
        { name: 'ssdetc', path: 'ssdetc', keywords: ['for kids', '6-12', 'strawberry'] },
        { name: 'ssdetc', path: 'ssdetc', keywords: ['for kids', '6-i 2', 'strawberry'] },
        { name: 'ssdetn', path: 'ssdetn', keywords: ['儿童牙膏', '2-6', '草莓口味'] },
        { name: 'ssdetn', path: 'ssdetn', keywords: ['for kids', '2-6', 'strawberry'] },

        ////////////////////////////////////////////
        { name: 'ssdjs', path: 'ssdjs', keywords: ['劲速护理'] },
        { name: 'hmjyhl', path: 'hmjyhl', keywords: ['pro专业', '护敏健龈', '焕亮美白'] },
        { name: 'hmjyqx', path: 'hmjyqx', keywords: ['pro专业', '护敏健龈', '清新美白'] },
        // { name: 'hyjhl', path: 'hyjhl', keywords: ['pro专业', '护釉健', '焕亮美白'] },
        // { name: 'hyjqs', path: 'hyjqs', keywords: ['pro专业', '护釉健', '沁爽薄荷'] },
        { name: 'hyjhl', path: 'hyjhl', keywords: ['护釉健', '美白', '包装'] },//老
        { name: 'hyjqs', path: 'hyjqs', keywords: ['护釉健', '薄荷', '包装'] },//老
        { name: 'hyjhl', path: 'hyjhl2', keywords: ['护釉健', '美白', '升级'] },//新
        { name: 'hyjqs', path: 'hyjqs2', keywords: ['护釉健', '薄荷', '升级'] },//新
        { name: 'dxzh', path: 'dxzh', keywords: ['多效臻护', '留兰清香'] },
        { name: 'qsjj', path: 'qsjj', keywords: ['沁爽劲洁', '薄荷沁香'] },
        { name: 'qsbh', path: 'qsbh', keywords: ['清新薄荷'] },
        { name: 'zyxfdc', path: 'zyxfdc', keywords: ['pro专业', '多重倍护'] },
        { name: 'zyxfjs', path: 'zyxfjs', keywords: ['pro专业', '专业修复', '劲爽薄荷'] },
        { name: 'zyxfmb', path: 'zyxfmb', keywords: ['pro专业', '专业修复', '美白配方', '屏障'] },//老
        { name: 'zyxfmb', path: 'zyxfmb2', keywords: ['pro专业', '专业修复', '美白配方', '敏感'] },//新
        //////////////////////////////////////////
        { name: 'ssddx', path: 'ssddx', keywords: ['多效护理'] },
        { name: 'ssdmb', path: 'ssdmb', keywords: ['美白配方', '精准修护'] },
        { name: 'ssdzy', path: 'ssdzy', keywords: ['专业修复', 'pro专业', '屏障'] },//老
        { name: 'ssdzy', path: 'ssdzy2', keywords: ['专业修复', 'pro专业', '敏感'] },//新
        { name: 'ssdyy', path: 'ssdyy', keywords: ['牙龈护理'] },
        { name: 'ssdqx', path: 'ssdqx', keywords: ['四重护齿矩阵', '茶'] },
        { name: 'ssdqs', path: 'ssdqs', keywords: ['四重护齿矩阵', '薄荷'] },
        { name: 'ysc', path: 'ysc', keywords: ['善存银片'] },
        { name: 'blfjjp', path: 'blfjjp', keywords: ['咀嚼'] },
        { name: 'ettz', path: 'ettz', keywords: ['白桃'] },
        { name: 'xbhrt', path: 'xbhrt', keywords: ['温和低研','薄荷'] },
        { name: 'hsjn', path: 'hsjn', keywords: ['小时','缓释'] },
        { name: 'fkp', path: 'fkp', keywords: ['酚咖'] },
        { name: 'blfrjn', path: 'blfrjn', keywords: ['软胶囊'] },
        { name: 'blfkl', path: 'blfkl', keywords: ['布洛芬颗粒'] },
        { name: 'blfhsj', path: 'blfhsj', keywords: ['布洛芬','金'] }
      ];
      let find = products.find(p => {
        let count = 0;
        p.keywords.forEach(w => {
          if (content.toLowerCase().indexOf(w) >= 0) {
            console.log('Match', w);
            count++;
          }
        });
        return count === p.keywords.length;
      });

      if (!find) {
        console.log('没找到', content);
        isOcring = false;
        //this.info.push('图片未能识别');
        return;
      }

      //this.info.push(`图片识别成功[${find.path}]`);
      //console.groupCollapsed('Content');
      console.log(content);
      //console.groupEnd();
      return find;
    }

    const hideAllAnchors = () => {
      counts = 0;
      if (!mindarThree) return;
      console.log('------hideAllAnchors')
      // 方法1：直接隐藏所有anchor组（推荐）
      mindarThree.anchors.forEach(anchor => {
        anchor.group.visible = false;
      });
      // 方法2：强制重新渲染
      mindarThree.renderer.render(mindarThree.scene, mindarThree.camera);
    };

    onMounted(() => {
      console.log('onMounted 注册')
      initAR();
      if (!timer) {
        console.log('注册')
        timer = setInterval(handleTakePhoto, 1000);
      }
    });

    onBeforeUnmount(() => {
      console.log('onBeforeUnmount')
      stopAR();
      if (mindarThree) {
        mindarThree.renderer.dispose();
      }
    });


    onUnmounted(() => {
      console.log('onUnmounted')
      stopAR();
      if (mindarThree) {
        mindarThree.renderer.dispose();
      }
    });


    return {
      container,
      startAR,
      stopAR,
      testOcr,
      pauseAR,
      hideAllAnchors,
      handleMessage,
      handleTakePhoto
    };
  }
};
</script>

<style>
.mindar-box {
  position: relative;
  width: 100vw;
  height: 100vh;

}


#container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
}
</style>